export default __webpack_public_path__ + "static/media/logo-lg-1024w.f4eadf58.avif";